module.exports = __webpack_public_path__ + "static/media/image1.4cc9531a.jpeg";